module.exports = __webpack_public_path__ + "img/singandplay.ecfdc98e.png";